import { formatLtcCostDisplay } from '@shared';
import { Tooltip, TooltipContent, TooltipTrigger } from '@design-system';
import { useLtcCostDisplayPrecision } from '@client/hooks/useLtcCostDisplayPrecision';

interface LtcCostDisplayProps {
  value: number | undefined | null;
  className?: string;
}

/**
 * Displays a projected LTC cost (or projected cost coverage) amount.
 * Uses advisor preference: precise (roundingStep 0) or round to nearest 10 / 100 / 1000.
 * When rounded, shows precise value on hover.
 */
export function LtcCostDisplay({ value, className }: LtcCostDisplayProps) {
  const roundingStep = useLtcCostDisplayPrecision();
  const { formattedDisplay, formattedPrecise } = formatLtcCostDisplay(value, {
    roundingStep,
  });

  if (roundingStep === 0) {
    return <span className={className}>{formattedDisplay}</span>;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={className}>{formattedDisplay}</span>
      </TooltipTrigger>
      <TooltipContent>
        <span>{formattedPrecise}</span>
      </TooltipContent>
    </Tooltip>
  );
}
